export const parseTextShadowString = (
  boxShadow?: string
): {
  offsetX: string | null;
  offsetY: string | null;
  blur: string | null;
  color: string | null;
} => {
  if (!boxShadow) {
    return {
      offsetX: null,
      offsetY: null,
      blur: null,
      color: null,
    };
  }

  const regex = /(-?\d*\.?\d+px)\s+(-?\d*\.?\d+px)\s+(-?\d*\.?\d+px)\s+(-?\d*\.?\d+px)?\s*#?([a-fA-F\d]*)?/;
  const matches = boxShadow.match(regex);

  if (!matches) {
    return {
      offsetX: null,
      offsetY: null,
      blur: null,
      color: null,
    };
  }

  const [, offsetX, offsetY, blur, , color] = matches;

  const formattedColor = color && !color.startsWith('#') ? `#${color}` : color || null;

  return {
    offsetX: offsetX || null,
    offsetY: offsetY || null,
    blur: blur || null,
    color: formattedColor || null,
  };
};
